import { useState, useEffect } from 'react'; 
import { BarChart } from '@mui/x-charts/BarChart';
import moneyFormat from '../functions/moneyFormat';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import Skeleton from '@mui/material/Skeleton';
import { blueberryTwilightPalette } from '@mui/x-charts/colorPalettes';

const SpendBarChart = ({ data, keys, axis, isLoading, colors }) => {
    // initialize chart state
    const [dataSet, setDataSet] = useState([]); 
    const [series, setSeries] = useState([{ 
        data: [1], 
        stack: 'A', 
        label: 'Loading', 
        yAxisKey: 'default' 
    }]); 
    const [yAxis, setYAxis] = useState([{
      id: 'default', scaleType: 'linear', 
    }]); 
    const [yAxisLeft, setYAxisLeft] = useState('default');
    const [yAxisRight, setYAxisRight] = useState(null); 
    const [colorPallete, setColorPallete] = useState();  

    // useEffect to run on axis change 
    useEffect(() => {
        if (axis) {
          let graphAxis = axis; 
          let left = null; 
          let right = null; 
          for (let i = 0; i < graphAxis.length; i++) {
            // set format for scale
            if (graphAxis[i]['id'] == 'spend') {
              graphAxis[i]['valueFormatter'] = (value) => { 
                return '$' + (value/1000000).toString() + 'M'
              }; 
            } 
            else if (graphAxis[i]['id'] == 'rebate') {
              graphAxis[i]['valueFormatter'] = (value) => { 
                return '$' + (value/1000).toString() + 'K'
              }; 
            } 
            // assign to sign based on i 
            if (i == 0) {
              left = graphAxis[i]['id']; 
            }
            if (i == 1) {
              right = graphAxis[i]['id']
            }
          }
          // set yAxis
          setYAxis(yAxis => yAxis = graphAxis); 
          setYAxisLeft(yAxisLeft => yAxisLeft = left); 
          setYAxisRight(yAxisRight => yAxisRight = right); 
        }
    }, [axis]); 

    // useEffect to run on render and data change 
    useEffect(() => {
        if ( data ) {
            // set data set
            setDataSet(dataSet => dataSet = data); 
        }
    }, [data]); 

    // useEffect to run on key change 
    useEffect(() => {
        if (keys) {
            let dataKeys = keys 
            for (let i = 0; i < dataKeys.length; i++) {
              dataKeys[i]['valueFormatter'] = (value) =>{ return moneyFormat(value) };

            }
            // set series
            setSeries(series => series = dataKeys); 
        }
    }, [keys]); 

    // useEffect to run on colors change 
    useEffect(() => {
        if (colors && colors.length > 0){
            setColorPallete(colorPallete => colorPallete = colors); 
        }
        else {
            setColorPallete(colorPallete => colorPallete = blueberryTwilightPalette); 
        }
    }, [colors]); 

    return (
        <>
            {isLoading ? 
            <>
              {/* <BarChart
                loading
                slotProps={{
                  noDataOverlay: { message: 'Loading Data....' },
                }}
                series={[]}
                width={640} 
                height={375}
              /> */}
              <Skeleton variant="rounded" height={335} />
            </>
            : <BarChart
                dataset={dataSet}
                xAxis={[{ scaleType: 'band', dataKey: 'xAxis' }]}
                series={series}
                height={375}
                borderRadius={15}
                slotProps={{
                    // legend: { hidden: true },
                }}
                yAxis={yAxis}
                yAxisLeft={yAxis}
                leftAxis={yAxisLeft}
                rightAxis={yAxisRight}
                colors={colorPallete}
                margin={{ left: 70, right: 70, top: 75 }}
                sx={{
                  [`.${axisClasses.left} .${axisClasses.label}`]: {
                    // Move the y-axis label with CSS
                    transform: 'translateX(-28px)',
                  },
                  [`.${axisClasses.right} .${axisClasses.label}`]: {
                    // Move the y-axis label with CSS
                    transform: 'translateX(28px)',
                  },
                  width: '90%',
                }}
              />}
        </> 
    ); 
}

export default SpendBarChart; 